(function () {
  var GIFT_VARIANT_ID = 48086754689268;
  var STORAGE_KEY = 'freegift_claimed';

  var params = new URLSearchParams(window.location.search);
  if (params.get('offer') !== 'FreeGift') return;
  if (localStorage.getItem(STORAGE_KEY)) return;

  // Clean the param from the URL without triggering a reload
  var cleanUrl = window.location.pathname + window.location.hash;
  history.replaceState(null, '', cleanUrl);

  fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({
      id: GIFT_VARIANT_ID,
      quantity: 1,
      properties: { _gift: 'Free gift' }
    })
  })
    .then(function (res) {
      if (!res.ok) throw new Error('Cart add failed: ' + res.status);
      return res.json();
    })
    .then(function () {
      localStorage.setItem(STORAGE_KEY, '1');
      document.dispatchEvent(
        new CustomEvent('theme:cartchanged', { bubbles: true, cancelable: false })
      );
      window.location.reload();
    })
    .catch(function (err) {
      console.error('[Free gift]', err);
    });
})();
